<!-- <app-lifestyle></app-lifestyle> -->

<div class="col-md-12 row clear-all flow-content">
  <app-header></app-header>
  <div class="container m-auto">
    <div class="top-container">
      <div class="breadcrumb-container">
        <app-breadcrumb></app-breadcrumb>
      </div>
      <div class="content-container">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>

<!-- <div>
  <router-outlet></router-outlet>
</div> -->